/**************************************************
 * Nombre:       Home_Mas_Vendidos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import linea from '../../../Recursos/Graficos/linea.svg'
import Tarjeta_Producto_Home from "../../Tarjetas/Tarjeta_Producto_Home";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";


const Home_Mas_Vendidos = () => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'center'}
                        size={{xs: 12, sm: 12, md: 12}}

                    >

                        <Grid container size={{xs: 12, sm: 12, md: 2}} sx={{justifyContent: sCell ? 'center' : 'flex-start'}}>
                            <Typography sx={{fontSize: 20, fontWeight: 800, lineHeight: 1.2}}>
                                PRODUCTOS MAS VENDIDOS
                            </Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 10}} sx={{justifyContent: 'flex-start'}}>
                            <img src={linea} width={'100%'}/>
                        </Grid>


                        <Grid
                            container
                            justifyContent={'center'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 11}}
                            spacing={sCell ? 4 : 6}
                            sx={{mt: 6}}
                        >

                            {items.map((item, i) => (
                                <Grid container size={{xs: 6, sm: 12, md: 4}} sx={{justifyContent: 'flex-start'}}>
                                    <Tarjeta_Producto_Home/>
                                </Grid>
                            ))}

                        </Grid>


                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Home_Mas_Vendidos

const items = [1, 2, 3, 4]

const itemsDos = [1, 2, 3]